import { render, staticRenderFns } from "./RightAside.vue?vue&type=template&id=fad96236&scoped=true&lang=true"
import script from "./RightAside.vue?vue&type=script&lang=js"
export * from "./RightAside.vue?vue&type=script&lang=js"
import style0 from "./RightAside.vue?vue&type=style&index=0&id=fad96236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad96236",
  null
  
)

export default component.exports